export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
